import EmbeddedLayout from '../../layouts/EmbeddedLayout';
import InitContent from '../shared/InitContent';

export default function EmbeddedInitPage() {
  return (
    <EmbeddedLayout>
      <InitContent />
    </EmbeddedLayout>
  );
}
